import { Box, Text, Image } from '@chakra-ui/react'
import React from 'react'

const Header = () => {
  return (
    <Box w='full' h={['100vh','100vh']} px={['3rem','1rem']} py='2rem'  bg={['#F5F8FF','']} display='flex' alignItems='center' justifyContent={['space-between','center']} flexDirection='column' >
        <Text fontSize={['32px','2rem','2.5rem','4rem']} mt={['','','','0']} fontWeight='500' lineHeight={['42px','']} fontFamily='Duplicate Sans' textAlign={['left','center']} noOfLines={['none','none','none','2']}>
        Building for the future of biometric 
payment in Africa
        </Text>
        <Text fontSize={['.75rem','1.05rem']} fontFamily='Work Sans' mt='1rem' textAlign={['left','center']} color='#445368'>We are focused team building to bring tommorrow’s solution to life, today.</Text>
        <Image m="auto"  w='full' src="/aboutheader.png" display={['block','none']} alt="mobile" />
    </Box>
  )
}

export default Header